module.exports = __webpack_public_path__ + "img/16.f0bdf0df.jpg";